import { MarkerType } from '@xyflow/react';

import { mdiFormatListText, mdiIframe, mdiSparkles, mdiUpload } from '@lumapps/lumx/icons';
import { DevicePermissionType } from '@lumapps/micro-apps-integrations/components/IframeComponent/types';
import { LumappsComponentType } from '@lumapps/micro-apps-integrations/constants';

import { MICROAPP } from './keys';

/** The class name for the drag handle element. */
export const DRAG_HANDLE_CLASSNAME = 'custom-drag-handle';

/** Maximum allowed size for a function action source code, in bytes (200 KB). */
export const MAX_FUNCTION_SOURCE_SIZE = 200 * 1024;

/** Maximum allowed size for a function action source code, in KB. */
export const MAX_FUNCTION_SOURCE_SIZE_KB = MAX_FUNCTION_SOURCE_SIZE / 1024;

/** The Micro-app Builder native agent ID.  */
export const AGENT_BUILDER_ID = '6368158e-7914-4cb9-a625-04b573fbd22a';

/**
 * Default options for links in the flow builder.
 */
export const DEFAULT_LINK_OPTIONS = {
    markerEnd: {
        type: MarkerType.ArrowClosed,
        width: 16,
        height: 16,
        color: '#666666',
    },
    style: { strokeWidth: 2, stroke: '#666666' },
};

/**
 * Default style for selected links in the flow builder.
 */
export const DEFAULT_LINK_SELECTED_STYLE = {
    stroke: '#245be7',
};

/**
 * Default style for handles in the flow builder.
 */
export const DEFAULT_HANDLE_STYLE = {
    border: 'none',
    width: '16px',
    height: '16px',
};

/** Material Design Icon path for 'arrow-down-right'. */
export const mdiArrowDownRight =
    'M21.5 14.5L16 20L10.5 14.5L11.91 13.09L15 16.17V10.5C15 8 13 6 10.5 6H4V4H10.5C14.09 4 17 6.91 17 10.5V16.17L20.09 13.08L21.5 14.5Z';

/** Material Design Icon path for a fork direction. */
export const mdiDirectionFork =
    'M7.64 12.4C6.63 11.5 5.34 11.03 4 11V14L0 10L4 6V9C5.67 9 7.3 9.57 8.63 10.59C8.22 11.15 7.89 11.76 7.64 12.4ZM16 14V11C15.5 11 11.5 11.16 11.05 15.2C12.61 15.75 13.43 17.47 12.88 19.03C12.33 20.59 10.61 21.41 9.05 20.86C7.5 20.3 6.67 18.59 7.22 17.03C7.5 16.17 8.2 15.5 9.05 15.2C9.34 11.61 12.4 8.88 16 9V6L20 10L16 14ZM11 18C11 17.7348 10.8946 17.4804 10.7071 17.2929C10.5196 17.1054 10.2652 17 10 17C9.73478 17 9.48043 17.1054 9.29289 17.2929C9.10536 17.4804 9 17.7348 9 18C9 18.2652 9.10536 18.5196 9.29289 18.7071C9.48043 18.8946 9.73478 19 10 19C10.2652 19 10.5196 18.8946 10.7071 18.7071C10.8946 18.5196 11 18.2652 11 18ZM9 10.12C9.58 9.46 10.25 8.89 11 8.43V4H14L10 0L6 4H9V10.12Z';

/** SVG path for the LumApps logo. */
export const mdiLumapps = `
    M13.9713 12.9417L10.0248 15.2452L6.07393 12.9417C5.99479 12.897 5.89792 12.8976 5.8193 12.9431C5.74067 12.9887 5.69204 13.0725 5.69143 13.1633V15.8711C5.69024 15.9624 5.73845 16.0472 5.81749 16.0928L10.0204 18.5528L14.2277 16.0971C14.3067 16.0515 14.355 15.9667 14.3538 15.8755V13.1633C14.3532 13.0725 14.3045 12.9887 14.2259 12.9431C14.1473 12.8976 14.0504 12.897 13.9713 12.9417Z
    M18.3434 4.11829L14.1144 1.70171C14.0353 1.65499 13.9371 1.65499 13.858 1.70171L11.5109 3.05343C11.4361 3.10032 11.3906 3.18243 11.3906 3.27075C11.3906 3.35907 11.4361 3.44118 11.5109 3.48807L15.4878 5.76121L15.4618 10.3336C15.4624 10.4245 15.511 10.5082 15.5896 10.5538C15.6682 10.5994 15.7651 10.5999 15.8442 10.5552L18.1826 9.20788C18.2616 9.16225 18.3098 9.07747 18.3086 8.98621L18.3391 4.11829H18.3434Z
    M8.49464 3.05795L6.15195 1.70188C6.07261 1.65607 5.97485 1.65607 5.89551 1.70188L1.6665 4.10977L1.68824 8.97769C1.68703 9.06895 1.73524 9.15373 1.81428 9.19936L4.15697 10.5554C4.23611 10.6001 4.33298 10.5995 4.4116 10.554C4.49023 10.5084 4.53886 10.4246 4.53945 10.3338V5.75704L8.51202 3.49693C8.58687 3.45004 8.63233 3.36793 8.63233 3.27961C8.63233 3.19129 8.58687 3.10918 8.51202 3.06229
    M13.4886 10.7941V7.01276C13.4874 6.93009 13.4429 6.85415 13.3713 6.81282L10.1202 4.91346C10.0476 4.87154 9.95809 4.87154 9.88547 4.91346L6.63005 6.81282C6.55845 6.85415 6.51387 6.93009 6.5127 7.01276V10.7941C6.51387 10.8767 6.55845 10.9527 6.63005 10.994L9.88547 12.8934C9.95784 12.9362 10.0478 12.9362 10.1202 12.8934L13.3756 10.994C13.4462 10.9522 13.4892 10.8761 13.4886 10.7941Z
        `;

/**
 * Enum for the different types of nodes (actions) in a micro-app flow.
 */
export enum NODE_ACTION {
    ADAPTIVE_CARD = 'adaptive_card',
    API_CALL = 'api_call',
    FUNCTION = 'function',
    ROUTER = 'router',
    TRIGGER = 'trigger',
    LUMAPPS_COMPONENT = 'lumapps_component',
    ITERATOR = 'group',
}

/**
 * Enum for the different types of links between nodes in a micro-app flow.
 */
export enum LINK_TYPE {
    DEFAULT = 'default',
    GO_BACK = 'go_back',
}

/**
 * Default template for the 'function' action source code.
 */
export const TEMPLATE_FUNCTION = `/**
 * Process data from the execution context in order to either reformat or create new data.
 * @param {Object)  executionContext  The execution context as a frozen object, you cannot update it directly.
 * @returns {Object}                  The result of your data processing which will be available in the next execution context.
 */
function main (executionContext) {
	// In this function, you can build an output from the execution context.
	// You can change the content of this function but do not rename it.
	// The result of this function will be available in the next action.


	// Declaration of the output variable.
	let output = {};
 
	// Your code here. For help, please go to https://docs.lumapps.com.


	// Mandatory: return your output.
	return output;
}`;

/** The translation scope for the micro-app builder. */
export const SCOPE = 'micro-app';

/**
 * Specify icon to display for each lumapps component action
 */
export const LUMAPPS_COMPONENT_ICON = {
    [LumappsComponentType.Uploader]: mdiUpload,
    [LumappsComponentType.FileList]: mdiFormatListText,
    [LumappsComponentType.AskAnswer]: mdiSparkles,
    [LumappsComponentType.Iframe]: mdiIframe,
};

/**
 * Specify description to display for each lumapps component action
 */
export const LUMAPPS_COMPONENT_DESCRIPTION = {
    [LumappsComponentType.Uploader]: MICROAPP.FILE_UPLOAD_COMPONENT,
    [LumappsComponentType.FileList]: MICROAPP.FILE_LIST_COMPONENT,
    [LumappsComponentType.AskAnswer]: MICROAPP.ASK_RESPONSE_DESCRIPTION,
    [LumappsComponentType.Iframe]: MICROAPP.IFRAME_COMPONENT,
};

/**
 * Valid values for the iframe sandbox attribute.
 */
export const SANDBOX_PERMISSION_OPTIONS = [
    'allow-downloads',
    'allow-forms',
    'allow-modals',
    'allow-orientation-lock',
    'allow-pointer-lock',
    'allow-popups',
    'allow-popups-to-escape-sandbox',
    'allow-presentation',
    'allow-same-origin',
    'allow-scripts',
    'allow-storage-access-by-user-activation',
    'allow-top-navigation',
    'allow-top-navigation-by-user-activation',
    'allow-top-navigation-to-custom-protocols',
];

/**
 * Maps each device permission type to its MICROAPP translation key.
 */
export const DEVICE_PERMISSION_LABEL_KEYS: Record<DevicePermissionType, MICROAPP> = {
    [DevicePermissionType.CAMERA]: MICROAPP.IFRAME_PERMISSION_CAMERA,
    [DevicePermissionType.MICROPHONE]: MICROAPP.IFRAME_PERMISSION_MICROPHONE,
    [DevicePermissionType.GEOLOCATION]: MICROAPP.IFRAME_PERMISSION_GEOLOCATION,
    [DevicePermissionType.ACCELEROMETER]: MICROAPP.IFRAME_PERMISSION_ACCELEROMETER,
    [DevicePermissionType.GYROSCOPE]: MICROAPP.IFRAME_PERMISSION_GYROSCOPE,
    [DevicePermissionType.MAGNETOMETER]: MICROAPP.IFRAME_PERMISSION_MAGNETOMETER,
    [DevicePermissionType.DISPLAY_CAPTURE]: MICROAPP.IFRAME_PERMISSION_SCREEN_SHARING,
    [DevicePermissionType.CLIPBOARD_WRITE]: MICROAPP.IFRAME_PERMISSION_CLIPBOARD_WRITE,
    [DevicePermissionType.CLIPBOARD_READ]: MICROAPP.IFRAME_PERMISSION_CLIPBOARD_READ,
    [DevicePermissionType.AMBIENT_LIGHT_SENSOR]: MICROAPP.IFRAME_PERMISSION_AMBIENT_LIGHT_SENSOR,
    [DevicePermissionType.AUTOPLAY]: MICROAPP.IFRAME_PERMISSION_AUTOPLAY,
    [DevicePermissionType.BLUETOOTH]: MICROAPP.IFRAME_PERMISSION_BLUETOOTH,
    [DevicePermissionType.ENCRYPTED_MEDIA]: MICROAPP.IFRAME_PERMISSION_ENCRYPTED_MEDIA,
    [DevicePermissionType.FULLSCREEN]: MICROAPP.IFRAME_PERMISSION_FULLSCREEN,
    [DevicePermissionType.GAMEPAD]: MICROAPP.IFRAME_PERMISSION_GAMEPAD,
    [DevicePermissionType.HID]: MICROAPP.IFRAME_PERMISSION_HID,
    [DevicePermissionType.IDLE_DETECTION]: MICROAPP.IFRAME_PERMISSION_IDLE_DETECTION,
    [DevicePermissionType.LOCAL_FONTS]: MICROAPP.IFRAME_PERMISSION_LOCAL_FONTS,
    [DevicePermissionType.MIDI]: MICROAPP.IFRAME_PERMISSION_MIDI,
    [DevicePermissionType.PAYMENT]: MICROAPP.IFRAME_PERMISSION_PAYMENT,
    [DevicePermissionType.PICTURE_IN_PICTURE]: MICROAPP.IFRAME_PERMISSION_PICTURE_IN_PICTURE,
    [DevicePermissionType.PUBLICKEY_CREDENTIALS_CREATE]: MICROAPP.IFRAME_PERMISSION_PUBLICKEY_CREDENTIALS_CREATE,
    [DevicePermissionType.PUBLICKEY_CREDENTIALS_GET]: MICROAPP.IFRAME_PERMISSION_PUBLICKEY_CREDENTIALS_GET,
    [DevicePermissionType.SCREEN_WAKE_LOCK]: MICROAPP.IFRAME_PERMISSION_SCREEN_WAKE_LOCK,
    [DevicePermissionType.SERIAL]: MICROAPP.IFRAME_PERMISSION_SERIAL,
    [DevicePermissionType.SPEAKER_SELECTION]: MICROAPP.IFRAME_PERMISSION_SPEAKER_SELECTION,
    [DevicePermissionType.STORAGE_ACCESS]: MICROAPP.IFRAME_PERMISSION_STORAGE_ACCESS,
    [DevicePermissionType.USB]: MICROAPP.IFRAME_PERMISSION_USB,
    [DevicePermissionType.WEB_SHARE]: MICROAPP.IFRAME_PERMISSION_WEB_SHARE,
    [DevicePermissionType.WINDOW_MANAGEMENT]: MICROAPP.IFRAME_PERMISSION_WINDOW_MANAGEMENT,
    [DevicePermissionType.XR_SPATIAL_TRACKING]: MICROAPP.IFRAME_PERMISSION_XR_SPATIAL_TRACKING,
};

/**
 * Enum representing the steps in the micro-app execution/run flow.
 */
export enum RunMicroAppStep {
    INPUT_VARIABLES = 'INPUT_VARIABLES',
    CONNECTORS = 'CONNECTORS',
    INTERFACE = 'INTERFACE',
}

/** Steps of the create API action dialog wizard. */
export enum ApiActionDialogStep {
    NAME = 0,
    PROVIDER = 1,
    SETTINGS = 2,
}

/** Ordered steps of the create API action dialog wizard. */
export const API_ACTION_DIALOG_STEPS = (Object.values(ApiActionDialogStep) as Array<ApiActionDialogStep>).filter(
    (step) => Number.isInteger(step),
);

/** Steps of the create function action dialog wizard. */
export enum FunctionActionDialogStep {
    NAME = 0,
    SETTINGS = 1,
}

/** Ordered steps of the create function action dialog wizard. */
export const FUNCTION_ACTION_DIALOG_STEPS = (
    Object.values(FunctionActionDialogStep) as Array<FunctionActionDialogStep>
).filter((step) => Number.isInteger(step));

/** URL for the LumApps provider icon. */
export const LUMAPPS_PROVIDER_ICON = 'https://design.lumapps.com/logo.svg';

/**
 * Enum for the source of an input variable.
 */
export enum InputVariableSource {
    DEVELOPER = 'developer',
    SYSTEM = 'system',
}

/**
 * Enum for the type of input variable.
 */
export enum InputVariableType {
    boolean = 'boolean',
    file = 'file',
    number = 'number',
    string = 'string',
}

/**
 * Translatable property names
 */
export enum TranslatablePropertyName {
    Title = 'title',
    Tooltip = 'tooltip',
    Text = 'text',
    ErrorMessage = 'errorMessage',
    Label = 'label',
    Placeholder = 'placeholder',
    Choices = 'choices',
}

/**
 * Elements types
 */
export enum TranslatableElementType {
    // Actions
    ActionExecute = 'Action.Execute',
    ActionSubmit = 'Action.Submit',
    ActionOpenUrl = 'Action.OpenUrl',
    ActionShowCard = 'Action.ShowCard',
    ActionToggleVisibility = 'Action.ToggleVisibility',

    // Text
    TextBlock = 'TextBlock',
    Badge = 'Badge',

    // Inputs
    InputText = 'Input.Text',
    InputNumber = 'Input.Number',
    InputDate = 'Input.Date',
    InputTime = 'Input.Time',
    InputToggle = 'Input.Toggle',
    InputChoiceSet = 'Input.ChoiceSet',

    // Container
    AdaptiveCard = 'AdaptiveCard',
    Container = 'Container',
    Column = 'Column',
    ColumnSet = 'ColumnSet',
    ActionSet = 'ActionSet',
}

/**
 * Maps element types to their translatable properties and corresponding field types
 */
export const TRANSLATABLE_PROPERTIES_CONFIG: Record<
    TranslatableElementType,
    Array<{ property: string; isNested?: boolean }>
> = {
    // Actions
    [TranslatableElementType.ActionExecute]: [
        { property: TranslatablePropertyName.Title },
        { property: TranslatablePropertyName.Tooltip },
    ],
    [TranslatableElementType.ActionSubmit]: [
        { property: TranslatablePropertyName.Title },
        { property: TranslatablePropertyName.Tooltip },
    ],
    [TranslatableElementType.ActionOpenUrl]: [
        { property: TranslatablePropertyName.Title },
        { property: TranslatablePropertyName.Tooltip },
    ],
    [TranslatableElementType.ActionShowCard]: [
        { property: TranslatablePropertyName.Title },
        { property: TranslatablePropertyName.Tooltip },
    ],
    [TranslatableElementType.ActionToggleVisibility]: [
        { property: TranslatablePropertyName.Title },
        { property: TranslatablePropertyName.Tooltip },
    ],

    // Text
    [TranslatableElementType.TextBlock]: [{ property: TranslatablePropertyName.Text }],
    [TranslatableElementType.Badge]: [
        { property: TranslatablePropertyName.Text },
        { property: TranslatablePropertyName.Tooltip },
    ],

    // Inputs
    [TranslatableElementType.InputText]: [
        { property: TranslatablePropertyName.Label },
        { property: TranslatablePropertyName.Placeholder },
        { property: TranslatablePropertyName.ErrorMessage },
    ],
    [TranslatableElementType.InputNumber]: [
        { property: TranslatablePropertyName.Label },
        { property: TranslatablePropertyName.Placeholder },
        { property: TranslatablePropertyName.ErrorMessage },
    ],
    [TranslatableElementType.InputDate]: [
        { property: TranslatablePropertyName.Label },
        { property: TranslatablePropertyName.Placeholder },
        { property: TranslatablePropertyName.ErrorMessage },
    ],
    [TranslatableElementType.InputTime]: [
        { property: TranslatablePropertyName.Label },
        { property: TranslatablePropertyName.Placeholder },
        { property: TranslatablePropertyName.ErrorMessage },
    ],
    [TranslatableElementType.InputToggle]: [
        { property: TranslatablePropertyName.Label },
        { property: TranslatablePropertyName.Title },
        { property: TranslatablePropertyName.ErrorMessage },
    ],
    [TranslatableElementType.InputChoiceSet]: [
        { property: TranslatablePropertyName.Label },
        { property: TranslatablePropertyName.Placeholder },
        { property: TranslatablePropertyName.ErrorMessage },
        { property: TranslatablePropertyName.Choices, isNested: true },
    ],

    // Container (contain nested elements)
    [TranslatableElementType.AdaptiveCard]: [],
    [TranslatableElementType.Container]: [],
    [TranslatableElementType.Column]: [],
    [TranslatableElementType.ColumnSet]: [],
    [TranslatableElementType.ActionSet]: [],
};
